import React from 'react';
import OptionBuilder from './OptionBuilder';
import Spinner from './Spinner';
import './OptionComboBuilder.css';

const OptionComboBuilder = ({
  stockSymbol,
  equityPrice,
  interest,
  dividendRatio,
  tradingDate,
  comboBuilders,
  setComboBuilders,
  addOptionBuilder,
  handleRemoveOption,
  handleUpdateOption,
  handleUpdateTitle,
  handleCopyBuilder,
  handleRemoveBuilder,
  handleDisplayPLChart,
  setIsLoading,
  isLoading,
  handleSave,
  handleReplaceOption,
  setToast,
}) => {
  const handleAddStock = (builderId) => {
    setComboBuilders((prev) =>
      prev.map((builder) => {
        if (builder.id === builderId) {
          const hasStock = builder.options.some((o) => o.cardType === 'stock');
          if (hasStock) {
            return builder;
          }
          const newStock = {
            id: `stock-${Date.now()}`,
            price: '',
            shares: '',
            cardType: 'stock',
            title: 'Stock',
            isNew: true
          };
          return { ...builder, options: [...builder.options, newStock] };
        }
        return builder;
      })
    );
  };

  const handleAddOption = (builderId) => {
    setComboBuilders((prev) =>
      prev.map((builder) => {
        if (builder.id === builderId) {
          const newOption = {
            id: `option-${Date.now()}`,
            strike: '',
            expiry: '',
            type: 'Call',
            premium: '',
            contract: '',
            impliedVolatility: '',
            cardType: 'option',
            title: 'Option',
            isNew: true
          };
          return { ...builder, options: [...builder.options, newOption] };
        }
        return builder;
      })
    );
  };

  

  

  return (
    <div className="option-combo-builder">
      {isLoading && <Spinner />}
      <div className="option-builder-header">
        <h2 className="text-2xl font-bold text-center my-4">{stockSymbol}</h2>
        <div className="option-builder-actions">

        </div>
      </div>

      <div className="combo-builder-list">
        {comboBuilders.map((builder) => (
          <div key={builder.id} className="relative border border-gray-300 p-2 my-2 rounded">
            <OptionBuilder
              builderId={builder.id}
              equityPrice={equityPrice}
              interest={interest}
              dividendRatio={dividendRatio}
              tradingDate={tradingDate}
              options={builder.options}
              onRemoveOption={(optionId) => handleRemoveOption(builder.id, optionId)}
              onUpdateOption={(optionId, field, value) => handleUpdateOption(builder.id, optionId, field, value)}
              onReplaceOption={(optionId, newOption) => handleReplaceOption(builder.id, optionId, newOption)}
              onRemoveBuilder={() => handleRemoveBuilder(builder.id)}
              onCopyBuilder={() => handleCopyBuilder(builder.id)}
              title={builder.title}
              onUpdateTitle={(newTitle) => handleUpdateTitle(builder.id, newTitle)}
              onAddStock={() => handleAddStock(builder.id)}
              onAddOption={() => handleAddOption(builder.id)}
              onSave={() => handleSave(builder.id)}
              hasStock={builder.options.some((o) => o.cardType === 'stock')}
              setToast={setToast}
            />
          </div>
        ))}
      </div>
      </div>
  );
};

export default OptionComboBuilder;
